var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-personal-user-avatar"},[_c('div',{staticClass:"the-personal-user-avatar__text",class:{ 'is-small': _vm.isSmall }},[_vm._v(" "+_vm._s(_vm.symbols)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }